import { Helmet } from 'react-helmet-async';
import { useEffect } from 'react';
// @mui
import { Container, Typography, Box } from '@mui/material';
// components
import { useNavigate } from 'react-router-dom';
import { useAppContext } from '../context';

// ----------------------------------------------------------------------

export default function CGVPage() {
  const { user } = useAppContext();
  const navigate = useNavigate();

  useEffect(() => {
    if (!user) {
      navigate('/login', { replace: true });
    }
  }, [user, navigate]);

  return (
    <>
      <Helmet>
        <title>CGV : Gino Boxing</title>
      </Helmet>

      <Container maxWidth="xl">
        <Typography variant="h4" sx={{ mb: 3 }}>
          Conditions Générales de Vente
        </Typography>

        <Box
          sx={{
            width: '100%',
            height: 'calc(100vh - 200px)',
            border: '1px solid',
            borderColor: 'divider',
            borderRadius: 1,
          }}
        >
          <iframe
            src="https://docs.google.com/document/d/1iSyUD5RQ0g9e5YJxeTNXjc7XCyDwbs0f/preview"
            width="100%"
            height="100%"
            style={{ border: 'none', borderRadius: '4px' }}
            title="Conditions Générales de Vente"
          />
        </Box>
      </Container>
    </>
  );
}
